import './styles.scss'
import React from 'react'
import ReactTooltip from 'react-tooltip'

const IconSwitchUI = ({ id, height, tooltip, onClick, getIcon, CustomTag = 'button' }) => (
  <CustomTag
    data-for={id}
    data-tip={tooltip || ''}
    className='icon-switch'
    onClick={() => typeof onClick === 'function' ? onClick() : {}}
  >
    <figure
      style={{
        height: height || '15px'
      }}
    >
      <img src={getIcon()} alt='' />
    </figure>
    {
      tooltip && <ReactTooltip id={id} html={true} />
    }
  </CustomTag>
)

export default IconSwitchUI
